import { render, staticRenderFns } from "./VideosSlideCreate.vue?vue&type=template&id=b1e97350&scoped=true"
import script from "./VideosSlideCreate.vue?vue&type=script&lang=js"
export * from "./VideosSlideCreate.vue?vue&type=script&lang=js"
import style0 from "./VideosSlideCreate.vue?vue&type=style&index=0&id=b1e97350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e97350",
  null
  
)

export default component.exports